<div class="table-column-name-and-avatar__container">
    <ax-avatar [imageUrl]="avatarUrl" [name]="getName()" [size]="'small'"></ax-avatar>
    <span class="table-column-name-and-avatar__name" [ngClass]="isNavigatable ? 'table-column-name-and-avatar__name--navigatable' : ''" (click)="navigate($event)">{{getName()}}</span>
</div>